import { lazy } from "react";

export const HlsVideo = lazy(() => import("./HlsVideo"));
